import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanBEApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  email: string;
  name: string;
  productId: string;
  rating: number;
  title: string;
  description: string;
  publish: string;
  date: string;
  images: string;
  epcId: string | null;
  viewedAt: string;
  action: string;
  actionPerformedAt: string | null;
  productName: string | null;
  brandName: string | null;
  category: string | null;
  productCode: string | null;
}

// edit api call
const fetchProductReviewsDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await eramanBEApi.get(`/admin/reviews/get?reviewId=${id}`);
  return response.data;
};

const useProductReviewsDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["productReviewsDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchProductReviewsDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useProductReviewsDocumentDetails };
